import {
    Field,
    FormikProps
} from 'formik';

import {
    FormikRadioCardGroup,
    FormikSwitch,
    FormikTextarea,
    FormikTextInput,
    PlatformFieldset
} from '@flexinet/ui-components';
import {Container} from "@mantine/core";
import {
    Product,
    ProductStatus
} from "../types.ts";


export const FormComponent = (_: FormikProps<Product>) => {


    return (
        <Container>
            <PlatformFieldset legend={'Product'}>

                <Field
                    name='name'
                    label='Name'
                    description='Please enter plan name'
                    component={FormikTextInput}
                    withAsterisk
                />
            </PlatformFieldset>


            <PlatformFieldset legend={'Details'}>
                <Field
                    name='shortDescription'
                    label='Short Description'
                    description='Please enter the product short descripiton'
                    component={FormikTextarea}
                    my={'xl'}
                />
                <Field
                    name='longDescription'
                    label='Long Description'
                    description='Please enter the product short descripiton'
                    component={FormikTextarea}
                    my={'xl'}
                />


            </PlatformFieldset>


            <PlatformFieldset legend={'Trial'}>

                <Field
                    name='freeTrial'
                    label='Free Trial Available'
                    description='Please specify if the product has a free trial available'
                    component={FormikSwitch}
                    my={'xl'}
                />
            </PlatformFieldset>


            <PlatformFieldset legend={'Media'}>

                <Field
                    name='productImage'
                    label='Product Image'
                    description='Please enter the product image'
                    component={FormikTextInput}
                    my={'xl'}
                />

            </PlatformFieldset>


            <PlatformFieldset legend={'Status'}>

                <Field
                    name='status'
                    label='Status'
                    description='Please enter status'
                    component={FormikRadioCardGroup}
                    data={
                        [
                            {
                                value: ProductStatus.Draft,
                                label: ProductStatus.Draft,
                            },
                            {
                                value: ProductStatus.Active,
                                label: ProductStatus.Active,
                            },
                            {
                                value: ProductStatus.Deprecated,
                                label: ProductStatus.Deprecated,
                            }
                        ]
                    }
                    withAsterisk
                    my={'xl'}
                />

            </PlatformFieldset>

        </Container>
    );
}